<ng-container [formGroup]="formGroup">
  <div class="add-attribute-btn">
    <button nz-button nzType="default" (click)="AddChildAttribute()">
      <nz-space>
        <i *nzSpaceItem class="fal fa-plus-circle"></i>
        <span *nzSpaceItem>{{'Add Child Attribute' | translate}}</span>
      </nz-space>
    </button>
  </div>
  <div class="child-attributes-table">
    <nz-table
      [nzData]="existedChildAttributes"
      [nzFrontPagination]="false"
      *ngIf="existedChildAttributes.length > 0"
    >
      <thead>
        <tr>
          <th nzWidth="10%"></th>
          <th nzWidth="40%">{{'Name' | translate}}</th>
          <th nzWidth="40%">{{'Label' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let child of existedChildAttributes; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <a [routerLink]="['/settings/attribute/edit/', child.Id]">{{
              child.Name
            }}</a>
          </td>
          <td>{{ child.Label }}</td>
        </tr>
      </tbody>
    </nz-table>
    <nz-table
      [nzData]="childAttributesToAdd"
      [nzFrontPagination]="false"
      *ngIf="childAttributesToAdd.length > 0"
    >
      <thead>
        <tr>
          <th nzWidth="50px"></th>
          <th>{{'Name' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let child of childAttributesToAdd; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <input
              nz-input
              type="text"
              [(ngModel)]="child.Name"
              [ngModelOptions]="{ standalone: true }"
            />
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
